<template lang="pug">
#chiarman
  about-us-header(:aboutUsCommon="aboutUsCommon")
  section.container.i_mb_10
    .row.i_mt_14.i_mt_md_10
      .col-12.text-center
        h2.title {{ shareholderServices.area01_Title }}
    .row.i_mt_10.i_mt_sm_6
      .col-12
        img.avatar.float-md-left.i_mr_sm_0.i_mr_10(
          :src="shareholderServices.area01_Image"
        )
        p.i_body_l.i_mt_sm_10(v-html="shareholderServices.area01_Content01")
        p.i_body_l(v-html="shareholderServices.area01_Content02")
        .chairman
          p.text-left.i_body 董事長
          img.signature(:src="shareholderServices.area01_SignImage")
  .container-fluid.bg_blue.i_pb_10
    section.container.i_pt_12
      .row.i_mb_8
        .col-12.text-center
          h2.title 歷年年報下載
      .row.flex-wrap.year_items(
        v-if="!isFileExpand ? rowIndex == 0 : true",
        v-for="(fileRow, rowIndex) in Math.ceil(shareholderServices.area02_AnnualReportList.length / displayAmount)"
      )
        .col-auto(
          v-for="(file, index) in shareholderServices.area02_AnnualReportList",
          v-if="index < (rowIndex + 1) * displayAmount && index >= rowIndex * displayAmount"
        )
          a.year_item.d-flex.align-items-center.i_mb_4(
            :href="file.FileURL",
            target="_blank"
          )
            svg-icon(iconClass="ic_download", className="icon")
            p.i_body_l.i_ml_2.i_pr_1 {{ file.Year }}
      .row.i_mt_8
        .collapse_btn(@click="fileExpand", :class="{ expand: isFileExpand }") {{ isFileExpand ? collapseText[1] : collapseText[0] }}
  section.container.i_mt_6
    .row.i_mb_8
      .col-12.text-center
        h2.title {{ shareholderServices.area03_Title }}
    .row
      .col-12
        .info.d-flex
          .left.text-center
            h5(v-if="currentShareholderMeeting") {{ currentShareholderMeeting.MeetingTitle }}
            p.i_body_l(v-if="currentShareholderMeeting") {{ currentShareholderMeeting.MeetingSubTitle }}
          .right
            a.item(
              v-if="currentShareholderMeeting",
              :href="item.FileURL",
              v-for="item in currentShareholderMeeting.MeetingFileList"
            )
              svg-icon(iconClass="ic_download", className="icon")
              p.i_body_l {{ item.FileName }}
    .row.i_mt_8
      .col-12.text-center
        router-link.see_more_btn.sm.btn_blue_ci.text-center(
          tag="a",
          :to="{ name: 'ShareholderServicesDetail' }"
        ) 查看歷年股東會資料
  .container-fluid.declare.bg_blue.i_mt_10
    section.container.i_ptb_8
      .row
        .col-12.text-center
          h2.title {{ shareholderServices.area04_Title }}
      .row.i_mt_4
        .col-12
          p.i_body_l(v-html="shareholderServices.area04_Content")
        .col-12.i_mt_8.i_mt_sm_4
          .title_btn.d-flex.justify-content-between.align-items-center(
            @click="relatedExpand"
          )
            h5.i_mb_4 相關規定
            svg-icon.d-md-none(
              iconClass="arrow_bottom_g",
              className="arrow_bottom_g",
              :class="{ expand: isRelatedExpand }"
            )
          .content(ref="relatedcontent")
            list-item.i_mr_6.i_mt_2.i_mt_sm_4(
              v-for="(item, index) in shareholderServices.area05_RuleList",
              :key="index",
              :item="item"
            )
        .col-12.i_mt_8.i_mt_sm_4
          .title_btn.d-flex.justify-content-between.align-items-center(
            @click="applyExpand"
          )
            h5.i_mb_4 申請書表
            svg-icon.d-md-none(
              iconClass="arrow_bottom_g",
              className="arrow_bottom_g",
              :class="{ expand: isApplyExpand }"
            )
          .content(ref="applycontent")
            list-item.i_mr_6.i_mt_2.i_mt_sm_4(
              v-for="(item, index) in shareholderServices.area05_ReportList",
              :key="index",
              :item="item"
            )
  custom-footer
</template>

<script>
import Velocity from "velocity-animate";

import aboutUsHeader from "@/components/common/Header";
import CustomFooter from "@/components/common/Footer";
import ListItem from "@/components/about_us/shareholder_services/Item";
import {
  getAboutUsCommon,
  getShareholderServices,
  getShareholderMeeting,
} from "@/json/about_us";

export default {
  name: "ShareholderServices",
  metaInfo() {
    return {
      title: this.shareholderServices.SEO_Title,
      meta: [
        {
          name: "description",
          content: this.shareholderServices.SEO_Description,
        },
      ],
    };
  },
  components: {
    "about-us-header": aboutUsHeader,
    "custom-footer": CustomFooter,
    "list-item": ListItem,
  },
  data() {
    return {
      displayAmount: 5,
      isFileExpand: false,
      isRelatedExpand: false,
      isApplyExpand: false,
      collapseText: ["查看更多歷年年報", "查看更少歷年年報"],

      aboutUsCommon: {},

      shareholderServices: {
        area02_AnnualReportList: [],
      },
      shareholderMeeting: {
        ShareholderMeetingList: [
          {
            MeetingTitle: "",
            MeetingSubTitle: "",
            MeetingFileList: [],
          },
        ],
      },
      currentShareholderMeeting: {},
    };
  },

  watch: {
    "$store.state.screenWidth": function (width) {
      this.setLayout(width);

      if (this.isRelatedExpand) {
        //取得元素完整高度
        var relatedContentHeight = this.$refs.relatedcontent.scrollHeight + 20;

        Velocity(
          this.$refs.relatedcontent,
          { maxHeight: relatedContentHeight, opacity: 1 },
          { duration: 0 }
        );
      }

      if (this.isApplyExpand) {
        //取得元素完整高度
        var applyContentHeight = this.$refs.applycontent.scrollHeight + 20;

        Velocity(
          this.$refs.applycontent,
          { maxHeight: applyContentHeight, opacity: 1 },
          { duration: 0 }
        );
      }
    },
  },
  created() {
    this.getAboutUsCommon();
    this.getShareholderServices();
    this.getShareholderMeeting();
  },
  mounted() {
    this.onResize();
    this.setLayout(this.$store.state.screenWidth);
  },
  methods: {
    onResize() {
      var thiz = this;

      window.onresize = function () {
        // 定義視窗大小變更通知事件
        thiz.$store.state.screenWidth = document.documentElement.clientWidth; //視窗寬度
      };
    },
    fileExpand() {
      this.isFileExpand = !this.isFileExpand;
    },
    relatedExpand() {
      this.isRelatedExpand = !this.isRelatedExpand;

      if (this.isRelatedExpand) {
        //取得元素完整高度
        var height = this.$refs.relatedcontent.scrollHeight + 20;

        Velocity(
          this.$refs.relatedcontent,
          { maxHeight: height, opacity: 1 },
          { duration: 300 }
        );
      } else {
        Velocity(
          this.$refs.relatedcontent,
          { maxHeight: 0, opacity: 0 },
          { duration: 300 }
        );
      }
    },
    applyExpand() {
      this.isApplyExpand = !this.isApplyExpand;

      if (this.isApplyExpand) {
        //取得元素完整高度
        var height = this.$refs.applycontent.scrollHeight + 20;

        Velocity(
          this.$refs.applycontent,
          { maxHeight: height, opacity: 1 },
          { duration: 300 }
        );
      } else {
        Velocity(
          this.$refs.applycontent,
          { maxHeight: 0, opacity: 0 },
          { duration: 300 }
        );
      }
    },
    setLayout(width) {
      if (width > 767) {
        this.displayAmount = 5;
      } else {
        this.displayAmount = 4;
      }
    },
    getAboutUsCommon() {
      getAboutUsCommon().then((response) => {
        this.aboutUsCommon = response.data;
      });
    },
    getShareholderServices() {
      getShareholderServices().then((response) => {
        this.shareholderServices = response.data;
      });
    },
    getShareholderMeeting() {
      getShareholderMeeting().then((response) => {
        this.shareholderMeeting = response.data;
        if (
          this.shareholderMeeting.ShareholderMeetingList &&
          this.shareholderMeeting.ShareholderMeetingList.length > 0
        ) {
          this.currentShareholderMeeting =
            this.shareholderMeeting.ShareholderMeetingList[0];
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/about_us/shareholder_services";
</style>
